<template>
	<ui-root v-if="loaded" :data="warning" :part="form" ref="warningRef" :errs="errors" :actions="dialogControls(env)"></ui-root>
</template>

<script setup lang="ts">
import {onMounted, onUnmounted, ref, watch, reactive} from "vue";
import {connectEventBus, injectEnv} from "@fd/Environment";
import type {Warning} from "@t/note/Warning";
import type {WithMeta} from "@t/fd/WithMeta";
import {dialogControls, FormDefinition} from "@t/fd/layout/FormDefinition";
import type {ErrorMap} from "@fd/PartInjectKeys";
import {NetworkResponse} from "@fd/Types";
import {useRouter,useRoute} from "vue-router";
import {useNavigationStore} from "@/store/NavigationStore.ts";
import UiRoot from "@fd/containers/UiRoot.vue";
import {InterfaceRoot} from "@t/fd/InterfaceRoot.ts";
import {getIntAttParam} from "@/router/Router.ts";
import {useVirtualRoute} from "@/router/virtual/VirtualRouter.ts";


const env = injectEnv();
const navStore = useNavigationStore();
const router = useRouter();
const route = useVirtualRoute();

const loaded = ref<boolean>(false);

const errors = reactive<ErrorMap>([]);
const warning = ref<Warning|null>(null);
const form = ref<InterfaceRoot<FormDefinition>|null>(null);
const bus = connectEventBus("WarningPage");
const warningRef = ref(null);

function receivedData(data:Warning & WithMeta):void {
	if (data.META) {
		form.value = data.META.form;
		delete data.META;
	}
	warning.value = data;
	loaded.value = true;
	if (warning.value && warning.value.pkey) {
		navStore.replace(warning.value.pkey);
	}
}

function loadData() {
	let endpoint = null;
	const id = route.query.id;
	if (id) {
		endpoint = "api/warnings/"+id+"?meta=true";
	} else {
		const customer = route.query.customer;
		endpoint = "api/warnings/init?meta=true&customer="+customer;
	}
	return env.net.fetch(endpoint)
			.then((result) => result.json())
			.then(receivedData);
}

function saveData():Promise<NetworkResponse> {
    return env.net.fetch("api/warnings/"+warning.value.id, "PUT", warning.value);
}

function createData():Promise<NetworkResponse> {
    return env.net.fetch("api/warnings", "POST", warning.value);
}

function sendData():Promise<NetworkResponse> {
	return (!warning.value.id || warning.value.id===0)?createData():saveData();
}

bus.onCommand(["save", "saveAndBack"], async (cmd) => {
	errors.length = 0;
	const response = await sendData();
	if (response.ok) {
		if (cmd === "save") {
			const data = await response.json();
			receivedData(data);
			if (warningRef.value) {
				warningRef.value.setDirty(false);
			}
		} else {
			// Go back
			router.back();
		}
		return "ok";
	} else {
		const data = await response.json();
		if (Array.isArray(data?.problems)) {
			for (let problem of data.problems) {
				errors.push(problem);
			}
		}
		console.error(response);
		return "fail";
	}
});

watch(() => route.query.id, loadData, { immediate: true });
navStore.defineMenu((mb) => mb.standardMenu());

onMounted(() => {
	navStore.forward(env.msg("menu.createWarning"));
});
</script>




